import {Observable, of, Subject, switchMap, takeUntil} from "rxjs";

export class YouTube {
  nativeElement;
  youtubeId;
  volume;
  myDiv;
  player;
  onError;
  onReady;
  onStateChange;


  constructor(nativeElement, youtubeId) {
    this.nativeElement = nativeElement;
    this.youtubeId = youtubeId;

  }

  init(): Observable<any> {
    return new Observable<any>(sub => {
      this.myDiv = document.createElement('div');
      this.myDiv.id = "player" + this.youtubeId;
      this.myDiv.style.position = 'absolute';
      this.myDiv.style.left = "0px";
      this.myDiv.style.top = "0px";
      this.myDiv.style.width = "100%"
      this.myDiv.style.height = "100%"
      this.myDiv.style['pointer-events'] = "none";
      this.nativeElement.appendChild(this.myDiv);
      const yt = window["YT"];
      this.player = new yt.Player(this.myDiv.id, {
        height: this.myDiv.clientHeight,
        width: this.myDiv.clientWidth,
        playerVars: {
          'playsinline': 1
        }
      });
      this.onReady = event => {
        this.player.setVolume(this.volume);
        this.myDiv.style['pointer-events'] = "";
        if (this.nativeElement!=null && this.nativeElement.firstChild!=null) {
          this.nativeElement.firstChild.style['pointer-events'] = "";
        }
        this.player.removeEventListener('onReady', this.onReady);
        this.onReady = null;
        sub.next('ready');
        sub.complete();
      }
      this.player.addEventListener('onReady', this.onReady);

    })
  }

  loadVideoById(videoId):Observable<any> {
    return of('a').pipe(
      switchMap( a=> {
        this.player.loadVideoById(videoId);
        let state = -1;
        let notAvalible = false;
        return new Observable<any>(sub => {
          this.onStateChange = event => {
            if (event.data==3) {
              state=3;
            }
            if (state==3 && event.data==-1) {
              notAvalible = true;
              console.warn('youtube video not available');
            }

            if (event.data == 0 || notAvalible) {
              this.player.removeEventListener('onStateChange', this.onStateChange);
              this.onStateChange = null;
              sub.next('videoEnd');
              sub.complete();
            }
          }
          this.player.addEventListener('onStateChange', this.onStateChange);
        })
      })
    )
  }

  dispose() {
    if (this.player!=null) {
      if (this.onReady!=null) {
        this.player.removeEventListener('onReady', this.onReady);
        this.onReady = null;
      }
      if (this.onStateChange!=null) {
        this.player.removeEventListener('onStateChange', this.onStateChange);
        this.onStateChange = null;
      }
      this.player.destroy();
      this.player = null;
    }
    if (this.nativeElement!=null && this.nativeElement.firstChild!=null) {
      this.nativeElement.removeChild(this.nativeElement.firstChild);
    }
    this.nativeElement = null;
    this.myDiv = null;
  }
}
